const Tabs: any = {
  regulatorySurvey: [
    { label: "Map view", url: "/regulatory-surveys/mapview" },
    { label: "List view", url: "/regulatory-surveys/listview" },
    { label: "Pinned", url: "/regulatory-surveys/pinned" }
  ],
  voluntarySurvey: [
    { label: "Map view voluntary", url: "/voluntary-surveys/mapview" },
    { label: "List view", url: "/voluntary-surveys/listview" },
    { label: "Pinned", url: "/voluntary-surveys/pinned" }
  ],
  dataPreferences: [
    { label: "Site summary", url: "/asset-summary/sites-summary" },
    { label: "Camera operator", url: "/asset-summary/camera-operator" }
  ]
};

export default Tabs;
